import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useDataProvider } from 'react-admin';
import type { GPDataProvider } from '../index';
import type {
  ReportClickSummaryCreate,
  ReportClickSummaryCreateParams,
} from '../CustomMethods/Report';
import { type ActionHook, type ActionOptions, stableSerialize } from './types';

export function useReportClickSummaryCreate(
  initialArgs?: ReportClickSummaryCreateParams,
  options?: ActionOptions<
    ReportClickSummaryCreateParams,
    Awaited<ReturnType<ReportClickSummaryCreate>>
  >,
): ActionHook<ReportClickSummaryCreateParams, Awaited<ReturnType<ReportClickSummaryCreate>>> {
  const dataProvider = useDataProvider<GPDataProvider>();
  const queryClient = useQueryClient();
  const mutation = useMutation<
    Awaited<ReturnType<ReportClickSummaryCreate>>,
    Error,
    ReportClickSummaryCreateParams
  >({
    ...options,
    mutationFn: (args) =>
      queryClient.fetchQuery({
        queryKey: [
          'custom-action',
          'reportClickSummaryCreate',
          stableSerialize(args ?? initialArgs),
        ],
        queryFn: () =>
          dataProvider.reportClickSummaryCreate(
            args ?? initialArgs ?? ({} as ReportClickSummaryCreateParams),
          ),
        staleTime: 5 * 60 * 1000,
      }),
  });
  return [
    (args, callOptions) =>
      mutation.mutateAsync(
        args ?? initialArgs ?? ({} as ReportClickSummaryCreateParams),
        callOptions,
      ),
    mutation,
  ];
}
